<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">College Commitment</div>
  </section>
  <form class="user-commitment-form" [formGroup]="userCommitmentForm">
    <section class="modal-content-container">
      <div>
        <label class="input-title required">Committed college name</label>
        <ng-select
          [items]="commitmentsList$ | async"
          bindLabel="name"
          bindValue="id"
          formControlName="commitedCollegeId"
          placeholder="Committed College Name"
          [minTermLength]="3"
          typeToSearchText="Please enter 3 or more characters"
          [loading]="commitmentLoading"
          [typeahead]="commitmentInput$"
          (change)="onCommitmentChanged($event)"
          notFoundText="No colleges found"
          appendTo="body"
          class="no-arrow"
        >
          <ng-template ng-loadingspinner-tmp>
            <div class="loader mr-5">
              <div class="ball1"></div>
              <div class="ball2"></div>
              <div class="ball3"></div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </section>
    <div *ngIf="summaryErrorMessage" class="flex justify-center items-center text-sienna">
      {{ summaryErrorMessage }}
    </div>
    <section class="modal-actions-container">
      <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
      <button alt="Save" class="btn btn-lg" (click)="onSubmit($event)">Save</button>
    </section>
  </form>
</div>
